module.exports = __webpack_public_path__ + "assets/avatar_sedan.5741d84e.svg";